import { render, staticRenderFns } from "./AssessmentWizard.vue?vue&type=template&id=78d83772&scoped=true"
import script from "./AssessmentWizard.vue?vue&type=script&lang=js"
export * from "./AssessmentWizard.vue?vue&type=script&lang=js"
import style0 from "./AssessmentWizard.vue?vue&type=style&index=0&id=78d83772&prod&lang=less&scoped=true"
import style1 from "./AssessmentWizard.vue?vue&type=style&index=1&id=78d83772&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d83772",
  null
  
)

export default component.exports